import React from 'react';

interface GeneralLedgerSummaryProps {
  accountCode: string;
  accountName: string;
  openingBalance: number;
  debitTotal: number;
  creditTotal: number;
  closingBalance: number;
}

const formatAmount = (amount: number): string => {
  return amount.toLocaleString('ja-JP', { maximumFractionDigits: 0 });
};

export const GeneralLedgerSummary: React.FC<GeneralLedgerSummaryProps> = ({
  accountCode,
  accountName,
  openingBalance,
  debitTotal,
  creditTotal,
  closingBalance,
}) => {
  return (
    <div data-testid="general-ledger-summary" style={{ marginTop: '16px' }}>
      <div style={{ marginBottom: '8px', fontWeight: 600 }}>
        {accountCode} {accountName}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <div>前期繰越</div>
          <div>{formatAmount(openingBalance)}</div>
        </div>
        <div>
          <div>借方合計</div>
          <div>{formatAmount(debitTotal)}</div>
        </div>
        <div>
          <div>貸方合計</div>
          <div>{formatAmount(creditTotal)}</div>
        </div>
        <div>
          <div>期末残高</div>
          <div>{formatAmount(closingBalance)}</div>
        </div>
      </div>
    </div>
  );
};
